var React = require('react');

function DevicesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 4h17a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-9v2h9a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H12a3 3 0 0 0-3 3v7h2V5a1 1 0 0 1 1-1zM2 28v-3h7v3H2zm-2-4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-5zm21 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6zm-5 0V16H6v5H4v-5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3v-2h3z","fill":"#fff"}));
}

DevicesIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = DevicesIcon;

DevicesIcon.default = DevicesIcon;
